/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import './gateway-info.scss';

/* eslint-disable import/no-unresolved, import/default */

import gatewayInfoTemplate from './gateway-info.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.gateway-info', [])
    .directive('agGatewayInfo', GatewayInfo)
    .name;

/*@ngInject*/
function GatewayInfo() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {},
        controller: GatewayInfoController,
        controllerAs: 'vm',
        templateUrl: gatewayInfoTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function GatewayInfoController($scope, $window, $log, types, agTypes, telemetryWebsocketService, agDeviceService) {
    let vm = this;

    vm.agTypes = agTypes;
    vm.loading = false;
    vm.gateways = [];
    vm.supportedGateways = [];
    vm.status = 'disabled';

    vm.openGateway = function (gateway) {
        if (!gateway || !gateway.url) {
            throw new Error('no admin url');
        }
        $window.open(gateway.url, '_blank');
    }

    function refresh () {
        vm.loading = true;
        try {
            vm.gateways.map(gw => unloadGateway(gw));
            vm.gateways = [];
            agDeviceService.getAllDevices().then(devices => {
                let gwEntities = devices.filter(device => {
                    return device.type == 'gateway';
                })
                gwEntities.map(gw => {
                    try {
                        loadGateway(gw)
                    } catch (err) {
                        $log.error('unable to load gateway', gw)
                        $log.error(err);
                    }
                })
            });
        } finally {
            vm.loading = false;
        }
    }
    refresh();

    function unloadGateway (gatewayId) {
        var gateway = vm.gateways.find(x => x.id == gatewayId);
        if (gateway) {
            telemetryWebsocketService.unsubscribe(gateway.subscriber);
            vm.gateways = vm.gateways.filter(x => x.id != gatewayId);
        }
    }

    function getSubtitle (gateway) {
        let note = gateway.additionalInfo?.note;
        let defaultValue = gateway.label || gateway.name;
        if (note && angular.isString(note) && note.trim()) {
            return note.trim().split('\n')[0] || defaultValue;
        } else {
            return defaultValue;
        }
    }

    function loadGateway (gateway) {
        var entityType = gateway.id.entityType;
        var entityId = gateway.id.id;
        var attributeScope = 'CLIENT_SCOPE';

        var subscriptionCommand = {
            entityType: entityType,
            entityId: entityId,
            scope: attributeScope
        };

        var type = attributeScope === types.latestTelemetry.value ?
            types.dataKeyType.timeseries : types.dataKeyType.attribute;

        var gatewayId = gateway.id.id;
        unloadGateway(gatewayId);
        var gatewayModel = {
            id: gatewayId,
            title: 'Gateway',
            url: '',
            supported: false,
            subtitle: gateway.name,
            name: gateway.name,
            connected: false,
            attributes: {},
            subscriber: {
                subscriptionCommands: [subscriptionCommand],
                type: type,
                onData: (data) => {
                    Object.assign(gatewayModel.attributes, extractAttributes(data.data));
                    
                    var isOnPremise = parseInt(gatewayModel.attributes.isOnPremise) || 0;
                    var proxyUrl = gatewayModel.attributes.proxyUrl;
                    var localUrl = gatewayModel.attributes.localUrl;
                    var proxyConnected = parseInt(gatewayModel.attributes.proxyConnected) || 0;
                    var isSupported = parseInt(gatewayModel.attributes.proxySupported) || 0;
                    
                    if (!isSupported) {
                        gatewayModel.url = '';
                        gatewayModel.connected = false;
                        gatewayModel.supported = false;
                    } else if (isOnPremise) {
                        gatewayModel.url = localUrl;
                        gatewayModel.connected = true;
                        gatewayModel.supported = true;
                    } else {
                        gatewayModel.url = proxyUrl;
                        gatewayModel.connected = proxyConnected && proxyUrl;
                        gatewayModel.supported = true;
                    }

                    if (!gatewayModel.connected) {
                        gatewayModel.subtitle = 'no connection';
                    } else {
                        gatewayModel.subtitle = getSubtitle(gateway);
                    }

                    vm.supportedGateways = vm.gateways.filter(x => x.supported);
                    var hasGateways = vm.supportedGateways.length > 0;
                    var hasDisconnectedGateways = vm.supportedGateways.find(x => !x.connected);
                    if (hasDisconnectedGateways) {
                        vm.status = 'error';
                    } else if (hasGateways) {
                        vm.status = 'ok';
                    } else {
                        vm.status = 'disabled';
                    }
                    //$log.info(gateway.name, 'updated', gateway, vm.status, gatewayModel);
                    $scope.$digest();
                }
            }
        };
        
        telemetryWebsocketService.subscribe(gatewayModel.subscriber);
        vm.gateways.push(gatewayModel);
    }

    function extractAttributes(data) {
        var result = {};
        for (var key in data) {
            let values = data[key];
            if (!values || values.length == 0) {
                continue
            }
            let value = values[0][1];
            result[key] = value;
        }
        return result;
    }
}
